import { Component } from '@angular/core';
import { ThemeService } from 'shared/services/parameter/theme.service';
import { ParameterModel, PaymentIconModel } from 'shared/services/parameter/parameter.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-footer-payment',
  templateUrl: './footer-payment.component.html',
  styleUrls: ['./footer-payment.component.scss'],
})
export class FooterPaymentComponent {
  parameter$: Observable<ParameterModel>;
  iconsToDisplay$: Observable<PaymentIconModel[]>;

  constructor(private themeService: ThemeService) {
    this.parameter$ = this.themeService.parameter$;

    // derive iconsToDisplay from the parameter observable
    this.iconsToDisplay$ = this.parameter$.pipe(
      map(param => 
        param?.paymentIcons
          ?.filter(icon => icon.enabled)
          .sort((a, b) => (a.orderIndex ?? 0) - (b.orderIndex ?? 0)) || []
      )
    );
  }
}
